var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.data),function(item){return _c('div',{key:item.id,staticClass:"text-container"},[(_vm.$slots.default)?_vm._t("default"):[_c('div',{domProps:{"innerHTML":_vm._s(item.label)}})]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }